import {
  loadUpcomingMaintenancesRequest,
  loadUpcomingMaintenancesSucceeded,
  loadUpcomingtMaintenancesFailed,
} from './actionCreators';
import type {
  DeleteRemindersRequest,
  EditRemindersRequest,
  SetupRemindersRequest,
} from './actions';
import { ActionTypes } from './actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  MaintenanceRequester,
  type UpcomingMaintenancesByStatus,
} from '@cobliteam/api-lib';

import { AlertTypes, showAlertActionCreator } from '@cobliteam/alert';
import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();

export const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

export function* requestUpcomingMaintenancesSaga() {
  try {
    const upcoming: UpcomingMaintenancesByStatus = yield call(
      maintenanceRequester.loadUpcomingMaintenances
    );
    yield put(loadUpcomingMaintenancesSucceeded(upcoming));
  } catch (err) {
    yield put(loadUpcomingtMaintenancesFailed());
    yield put(
      showAlertActionCreator(
        AlertTypes.ERROR,
        'Falha ao carregar avisos de manutenção. Tente novamente mais tarde.'
      )
    );
  }
}

export function* requestEditRemindersSaga(action: EditRemindersRequest) {
  try {
    yield call(
      maintenanceRequester.editReminders,
      action.payload.vehicleId,
      action.payload.recurrences
    );
    yield put(
      showAlertActionCreator(
        AlertTypes.SUCCESS,
        'Recorrências editadas com sucesso!'
      )
    );
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    yield put(
      showAlertActionCreator(AlertTypes.ERROR, 'Falha ao editar recorrências.')
    );
  }
}

export function* requestDeleteRemindersSaga(action: DeleteRemindersRequest) {
  try {
    yield call(maintenanceRequester.deleteReminders, action.payload);
    yield put(
      showAlertActionCreator(
        AlertTypes.SUCCESS,
        'Lembretes descadastrados com sucesso!'
      )
    );
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    yield put(
      showAlertActionCreator(
        AlertTypes.ERROR,
        'Falha ao descadastrar lembretes de manutenção.'
      )
    );
  }
}

export function* requestSetupRemindersSaga(action: SetupRemindersRequest) {
  try {
    yield call(maintenanceRequester.setupMaintanenceReminders, action.payload);
    yield put(
      showAlertActionCreator(
        AlertTypes.SUCCESS,
        'Lembretes salvos com sucesso!'
      )
    );
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    yield put(
      showAlertActionCreator(
        AlertTypes.ERROR,
        'Falha ao salvar lembretes de manutenção.'
      )
    );
  }
}

export function* UpcomingMaintenancesSagasListener() {
  yield all([
    takeLatest(
      ActionTypes.LOAD_UPCOMING_MAINTENANCES_REQUEST,
      requestUpcomingMaintenancesSaga
    ),
    takeLatest(ActionTypes.EDIT_REMINDERS_REQUEST, requestEditRemindersSaga),
    takeLatest(
      ActionTypes.DELETE_REMINDERS_REQUEST,
      requestDeleteRemindersSaga
    ),
    takeLatest(ActionTypes.SETUP_REMINDERS_REQUEST, requestSetupRemindersSaga),
  ]);
}
